import { Component, type ErrorInfo, type ReactNode } from "react";
import { Banner, Button } from "@/shared/ui";

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Galaxy ErrorBoundary", error, info);
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="mx-auto max-w-lg p-6">
          <Banner tone="danger" title={this.state.error.message} />
          <Button
            className="mt-4"
            variant="secondary"
            onClick={() => {
              this.setState({ error: null });
              window.location.assign("/ops");
            }}
          >
            Về Ops
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
